import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import MetaData from "../layout/MetaData";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { saveLabour } from "../../redux/features/userAddressInfoSlice";

const LabourDetail = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [requiredLaboursStart, setRequiredLaboursStart] = useState("");
  const [noOfLaboursStart, setNoOfLaboursStart] = useState("");
  const [buildingFloorsStart, setBuildingFloorsStart] = useState("");
  const [cargoLiftStart, setCargoLiftStart] = useState("");

  const [requiredLaboursDestination, setRequiredLaboursDestination] = useState("");
  const [noOfLaboursDestination, setNoOfLaboursDestination] = useState("");
  const [buildingFloorsDestination, setBuildingFloorsDestination] = useState("");
  const [cargoLiftDestination, setCargoLiftDestination] = useState("");

  const { labour } = useSelector((state) => state.userAddressInfo);

  useEffect(() => {
    if (labour) {
      setRequiredLaboursStart(labour?.requiredLaboursStart);
      setNoOfLaboursStart(labour?.noOfLaboursStart);
      setBuildingFloorsStart(labour?.buildingFloorsStart);
      setCargoLiftStart(labour?.cargoLiftStart);
      setRequiredLaboursDestination(labour?.requiredLaboursDestination);
      setNoOfLaboursDestination(labour?.noOfLaboursDestination);
      setBuildingFloorsDestination(labour?.buildingFloorsDestination);
      setCargoLiftDestination(labour?.cargoLiftDestination);
    }
  }, [labour]);

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(saveLabour({ cargoLiftDestination, buildingFloorsDestination, noOfLaboursDestination, requiredLaboursDestination, cargoLiftStart, buildingFloorsStart, noOfLaboursStart, requiredLaboursStart }));
    navigate("/goods-info");
  };

  return (
    <>
      <MetaData title="Labour Detail" />
      <div className="row wrapper mb-5">
        <div className="col-10 col-lg-5">
          <form className="shadow rounded bg-body" onSubmit={submitHandler}>
            <h2 className="mb-4 text-center">Labour Details</h2>

            <h4 className="mb-3 text-primary fw-semibold">Pickup Address</h4>

            <div className="mb-3">
              <label htmlFor="requiredLaboursStart_field" className="form-label">Need labour at pickup?</label>
              <div className="form-check form-switch">
                <input className="form-check-input" type="checkbox" id="requiredLaboursStart_field" checked={requiredLaboursStart} onChange={(e) => setRequiredLaboursStart(e.target.checked)} />
                <label className="form-check-label" htmlFor="requiredLaboursStart_field">
                  {requiredLaboursStart ? "Labour: ON" : "Labour: OFF"}
                </label>
              </div>
            </div>

            {requiredLaboursStart && (
              <>
                <div className="mb-3">
                  <label className="form-label">Number of Labours</label>
                  <input type="number" className="form-control" onChange={(e) => setNoOfLaboursStart(e.target.value)} required />
                </div>
                <div className="mb-3">
                  <label className="form-label">Loading Floors</label>
                  <input type="number" className="form-control" onChange={(e) => setBuildingFloorsStart(e.target.value)} required />
                </div>
                <div className="mb-3">
                  <label className="form-label">Cargo Lift Available?</label>
                  <div className="form-check form-switch">
                    <input className="form-check-input" type="checkbox" checked={cargoLiftStart} onChange={(e) => setCargoLiftStart(e.target.checked)} />
                  </div>
                </div>
              </>
            )}

            <h4 className="mb-3 mt-4 text-primary fw-semibold">Destination Address</h4>

            <div className="mb-3">
              <label htmlFor="requiredLaboursDest_field" className="form-label">Need labour at destination?</label>
              <div className="form-check form-switch">
                <input className="form-check-input" type="checkbox" id="requiredLaboursDest_field" checked={requiredLaboursDestination} onChange={(e) => setRequiredLaboursDestination(e.target.checked)} />
                <label className="form-check-label" htmlFor="requiredLaboursDest_field">
                  {requiredLaboursDestination ? "Labour: ON" : "Labour: OFF"}
                </label>
              </div>
            </div>

            {requiredLaboursDestination && (
              <>
                <div className="mb-3">
                  <label className="form-label">Number of Labours</label>
                  <input type="number" className="form-control" onChange={(e) => setNoOfLaboursDestination(e.target.value)} required />
                </div>
                <div className="mb-3">
                  <label className="form-label">Loading Floors</label>
                  <input type="number" className="form-control" onChange={(e) => setBuildingFloorsDestination(e.target.value)} required />
                </div>
                <div className="mb-3">
                  <label className="form-label">Cargo Lift Available?</label>
                  <div className="form-check form-switch">
                    <input className="form-check-input" type="checkbox" checked={cargoLiftDestination} onChange={(e) => setCargoLiftDestination(e.target.checked)} />
                  </div>
                </div>
              </>
            )}

            <button id="shipping_btn" type="submit" className="btn btn-primary w-100 py-2 mt-4">
              Continue
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default LabourDetail;